import './VideoSection.scss';

const VideoSection = () => {
  const videos = [
    {
      id: 1,
      title: 'PDF를 HWP로 변환',
      videoId: '5t8QdhbCJWA',
      isFree: false
    },
    {
      id: 6,
      title: 'PDF를 HWP로 변환',
      videoId: '3YvXcImvc1Q',
      isFree: false,
      isPro: true
    },
    {
      id: 2,
      title: '수학 문제 풀이 AI',
      videoId: '7XbkG6eLJ2g',
      isFree: true
    },
    {
      id: 3,
      title: '수학 문제 변형 AI',
      videoId: 'kd3Hfs9LSBg',
      isFree: true
    },
    {
      id: 4,
      title: '수학 도형 그리기 AI',
      videoId: 'KX5iIhxSN_w',
      isFree: true
    },
    {
      id: 5,
      title: '수학 도형 전용 그림판',
      videoId: 'ChVMaxyzlVQ',
      isFree: true
    }
  ];

  return (
    <section id="video" className="video-section section">
      <div className="container">
        <header className="header">
          <h2 className="title">
            <span className="title-accent">실제 동작</span> 시연 영상
          </h2>
          <p className="subtitle">직접 확인하는 생생한 사용 경험</p>
        </header>

        <div className="video-grid">
          {videos.map((video) => (
            <div key={video.id} className="video-item">
              <h3 className="video-title">
                {video.title}
                {/* {video.isFree && <span className="free-badge">무료</span>} */}
                {video.isPro && <span className="pro-badge">PRO</span>}
              </h3>
              <div className="video-wrapper">
                <div className="video-container">
                  <div className="video-frame">
                    <iframe
                      src={`https://www.youtube.com/embed/${video.videoId}`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;

